
























































































































































/** @format */
import { Component, Mixins } from 'vue-property-decorator';
import TableMixin from '@root/common/mixins/table';
// 下拉框封装组件
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import Utils from '@root/utils/common';
import moment from 'moment';
import PlateInput from '@/components/plate-input/index.vue';
// 接口
import { discountSummaryRecord, exportDiscountSummaryRecord } from '../../../api/order-management';
import { distributionChannelsMap, ParkLotFormatMap } from '@/types/order-management/dictionaries';
import { couponTypeMap } from '@/types/discount-management/dictionaries';
@Component({
  name: 'DiscountSummaryRecord',
  components: { ParkingLotSearch, PlateInput }
})
// @ts-ignore
export default class DiscountSummaryRecord extends Mixins(TableMixin) {
  plateInputModel = false;
  private filterParam: any = {
    parkIds: [], //选中的车场
    plat: '',
    startDate: moment().format('YYYY-MM-DD') + ' 00:00:00',
    endDate: '',
    parkTypes: '',
    tradeNo: '',
    couponTypes: [],
    couponSource: [],
    couponName: '',
    pkCouponLogId: ''
  };
  currPage = 1;
  downLoading = false;
  private pageSize = 10;
  private totalNum = 0;
  private totalPage = 1;
  private current = 1;
  // private formatList: any[] = Utils.toLabelVal(ParkLotFormatMap) || []
  private tableData: any[] = [];
  private tableLoading: boolean = false;
  set defaultTime(val: any) {}
  private moment = moment;
  private disabledDate(current: any) {
    return current && current >= moment().endOf('day');
  }
  // private distributionChannelsList = Utils.toLabelVal(distributionChannelsMap) || []
  formatList = Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.cp_base_park_park_type);
  distributionChannelsList = Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.cp_merchant_source_type);
  options = Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.cp_merchant_coupon_coupon_type);

  //搜索时间配置
  private onTimeChange(date: any, dateString: any) {
    let [operateTimeStart, operateTimeEnd] = dateString;
    this.filterParam.startDate = operateTimeStart;
    this.filterParam.endDate = operateTimeEnd;
  }
  get defaultTime() {
    if (this.filterParam.startDate && this.filterParam.endDate) {
      return [
        this.moment(this.filterParam.startDate, 'YYYY-MM-DD HH:mm:ss'),
        this.moment(this.filterParam.endDate, 'YYYY-MM-DD HH:mm:ss')
      ];
    } else if (this.filterParam.startDate) {
      return [this.moment(this.filterParam.startDate, 'YYYY-MM-DD HH:mm:ss')];
    } else {
      return [];
    }
  }
  //table列表
  get tableColums() {
    return [
      {
        title: '序号',
        width: 55,
        customRender: (text: any, record: any, index: number) => {
          if (record.isTotal === true) {
            return '合计';
          }
          return `${(this.current - 1) * this.pageSize + index + 1}`;
        }
      },
      {
        title: '车场名称',
        dataIndex: 'parkName',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '项目名称',
        dataIndex: 'projectName',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '交易流水号',
        dataIndex: 'tradeNo',
        width: 200,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },

      {
        title: '车牌号',
        dataIndex: 'plate',
        width: 140,
        customRender: (text: any) => text || '--'
      },
      {
        title: '发放渠道',
        dataIndex: 'couponSource',
        width: 140,
        customRender: (text: any) => text || '--'
      },
      {
        title: '优惠类型',
        dataIndex: 'couponType',
        width: 220,
        customRender: (text: any) => text || '--'
      },
      {
        title: '优惠名称',
        dataIndex: 'couponName',
        width: 180,
        // customRender: (text: any) => text || '--',
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '优惠券号',
        dataIndex: 'pkCouponLogId',
        width: 200,
        // customRender: (text: any) => text || '--',
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '预发售',
        dataIndex: 'settlementWay',
        width: 120,
        // customRender: (text: any) => text || '--',
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '使用时间',
        dataIndex: 'useTime',
        width: 200,
        customRender: (text: any) => text || '--'
      },
      {
        title: '优惠金额',
        dataIndex: 'price',
        width: 160,
        customRender: (text: any) => text || '--'
      }
      // {
      //   title: '操作',
      //   dataIndex: 'operation',
      //   fixed: 'right',
      //   width: 220,
      //   scopedSlots: { customRender: 'operation' },
      // },
    ];
  }

  showSizeChangerChange(current: any, pageSize: any) {
    this.currPage = current;
    this.pageSize = pageSize;
    this.fetchTableData(false);
  }
  /**
   * 生命周期钩子函数
   */
  created() {
    // 特殊车辆类型列表初始化
    this.fetchTableData();
  }
  //搜索
  searchTable() {
    this.fetchTableData();
  }
  async fetchTableData(isRefresh?: boolean) {
    try {
      if (this.tableLoading) return;
      this.tableLoading = true;
      if (isRefresh) this.current = 1;
      const res = await discountSummaryRecord({
        ...this.filterParam,
        parkIds: this.filterParam.parkIds.join(','),
        couponSource: this.filterParam.couponSource.join(','),
        couponTypes: this.filterParam.couponTypes.join(','),
        page: this.current,
        pageSize: this.pageSize
      });
      const { datas, totalNum, totalPage, currPage, pageSize } = res.data;
      this.tableData = [];
      this.totalNum = Number(totalNum);
      this.totalPage = Number(totalPage);
      if (datas.length > 0) {
        datas.push({
          // totalAmount: totalAmounts || 0,
          key: 'sum',
          isTotal: true,
          price: res.data.totalCurrDiscountPrice || 0
        });
        this.tableData = Object.freeze(datas);
      }
      console.log(res);
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }
  //清空列表
  onTableFilterClear({ defaultParkIdList }) {
    this.plateInputModel = true;
    this.filterParam = {
      parkIds: defaultParkIdList, //选中的车场
      plat: '',
      startDate: moment().format('YYYY-MM-DD') + ' 00:00:00',
      endDate: '',
      parkTypes: '',
      tradeNo: '',
      couponSource: [],
      couponName: '',
      pkCouponLogId: '',
      couponTypes: []
    };
    this.fetchTableData(true);
  }

  //导出
  async downLoad() {
    try {
      if (this.downLoading) return;
      this.downLoading = true;
      await exportDiscountSummaryRecord({
        ...this.filterParam,
        parkIds: this.filterParam.parkIds.join(','),
        couponSource: this.filterParam.couponSource.join(','),
        couponTypes: this.filterParam.couponTypes.join(',')
      });
    } catch (error) {
      console.log(error);
    } finally {
      this.downLoading = false;
    }
  }
  // 车牌改变
  plateChange([plateHead, plateTail]: any, b: any) {
    this.filterParam.plat = plateHead + plateTail;
  }
}
